export default "__VITE_ASSET__BdxoCcIp__"